<template>
    <div class="operation_box">
        <div class="operation_item">
            <el-dropdown
                    v-if="this.upTabType === 'new' || this.upTabType === 'rejected'"
                    split-button type="primary"
                    @click="clickEdit"
                    @command="(command) => command()"
            >
              <i class="fa fa-pencil"></i>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="clickEdit">
                  <i class="fa fa-pencil"></i> {{$t('common.edit')}}
                </el-dropdown-item>
                <el-dropdown-item :command="clickSubmit" :disabled="!shouldShowSubmit()">
                  <i class="fa fa-paper-plane"></i> {{$t('common.button.toReview')}}
                </el-dropdown-item>
                <el-dropdown-item :command="clickDelete" v-if="this.upTabType !== 'rejected'">
                  <i class="fa fa-trash-o"></i> {{$t('common.delete')}}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <div @click="clickDetails" v-if="this.upTabType === 'waiting'">
                <md-button class="md-blank"><i class="fa fa-search-plus" style="text-align: left"></i><span>{{ $t("common.details") }}</span></md-button>
            </div>
        </div>
    </div>
</template>
<script>
import {mapGetters} from "vuex";
import {hasAccess} from "@/common/permission/permission";
import {enumDef} from "@/common/enumDefs";

export default {
  methods: {
    clickEdit() {
      let { data } = this.params;
      this.$store.dispatch("setActionPdfDialog", { show: true, data: data });
      if (data) {
        this.$store.dispatch("setActionPdfList", [data]);
      }
    },
    clickDelete() {
      let { data, colDef } = this.params;
      colDef.delFun(data);
    },
    clickSubmit() {
      let { data, colDef } = this.params;
      colDef.setFun(data);
    },
    clickDetails() {
		let { data} = this.params;
		this.$store.dispatch("setActionNoticModal", {
			show: true,
			data: {
				title: this.$t("ReceDetail.Receivable.Details"),
				type: "ReceivableDetailsModal",
				width: 800,
				data: data
			}
		});
    },
	  shouldShowSubmit: function () {
		  let {data} = this.params;
		  return !!(data.invoiceNumber && data.invoiceDocument)
			  && hasAccess(this.currentUser, enumDef.permissions.SellerSellReceivables);
	  }
  },
  computed: {
    ...mapGetters({ upTableData: "upTableData", upTabType: "upTabType" })
  }
};
</script>
